export default __webpack_public_path__ + "static/media/police-brutality-grp.65891904.png";